// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
    AddRoleToUser,
    ApplicationRole,
    RemoveRoleFromUser,
    UserApplicationRole,
    UserApplicationRoleDetailed,
} from "./types/applicationRolesTypes";
import { Config } from "../config";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedApplicationRolesApi = createApi({
    reducerPath: "cclTokenedApplicationRolesApi ",
    tagTypes: ["users", "roles"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllUsersWithRoles: builder.query<UserApplicationRoleDetailed[], void>({
            query: () => ({
                url: "ccl-access2-data/v1.0/ApplicationRoles/users",
                method: "GET",
            }),
            providesTags: ["users"],
        }),
        getAllRoles: builder.query<ApplicationRole[], void>({
            query: () => ({
                url: "ccl-access2-data/v1.0/ApplicationRoles/roles",
                method: "GET",
            }),
            providesTags: ["roles"],
        }),
        addRoleToUser: builder.mutation<UserApplicationRole, AddRoleToUser>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/ApplicationRoles/users/add-user",
                method: "POST",
                body: args,
            }),
            invalidatesTags: ["users"],
        }),
        removeRolefromUser: builder.mutation<boolean, RemoveRoleFromUser>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/ApplicationRoles/users/remove-user",
                method: "DELETE",
                body: args,
            }),
            invalidatesTags: ["users"],
        }),
        getUserRoleByImKey: builder.query<UserApplicationRoleDetailed, number>({
            query: (imKey) => ({
                url: `ccl-access2-data/v1.0/ApplicationRoles/roles/users/${imKey}`,
                method: "GET",
            }),
            providesTags: ["users"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAllUsersWithRolesQuery,
    useGetAllRolesQuery,
    useAddRoleToUserMutation,
    useRemoveRolefromUserMutation,
    useGetUserRoleByImKeyQuery,
    useLazyGetUserRoleByImKeyQuery,
} = cclTokenedApplicationRolesApi;
